import React from 'react';
import {Grid} from '@material-ui/core';
import {deleteNotification, useWorksheet} from 'api';
import useSnackBar from 'shared/SnackBar/useSnackBar';
import NotificationBox from "./NotificationBox";
import {Authorize} from '@postinumero/authorization';

export default function Layout() {
  const worksheet = useWorksheet();

  const {showError} = useSnackBar();

  const removeNotification = (id) => {
    deleteNotification(id)
      .catch((err) => showError(err.response));
  };

  return (
    <Grid container item xs={12} alignItems="flex-start">
      <Authorize allow={['Account operator']} fallback={null}>
        <Grid container item xs={6} spacing={2}>
          <Grid item xs={12}>
            <NotificationBox
              title={'notifications.readyForInvoicing'}
              notifications={worksheet.readyToInvoice}
              subString={'invoicingPeriod'}
              removeNotification={removeNotification}
              icon={'assignment'}
            />
          </Grid>
          <Grid item xs={12}>
            <NotificationBox
              title={'notifications.lockedDateChanged'}
              notifications={worksheet.lockedDateChanged}
              subString={'invoicingPeriod'}
              removeNotification={removeNotification}
              icon={'assignment'}
            />
          </Grid>
        </Grid>
        <Grid container item xs={6} spacing={2}>
          <Grid item xs={12}>
            <NotificationBox
              title={'notifications.readyToSend'}
              notifications={worksheet.readyToSend}
              subString={'invoiceTo'}
              removeNotification={removeNotification}
              icon={'callMade'}
            />
          </Grid>
          <Grid item xs={12}>
            <NotificationBox
              title={'notifications.markedPaid'}
              notifications={worksheet.paid}
              subString={'invoiceTo'}
              removeNotification={removeNotification}
              icon={'callMade'}
            />
          </Grid>
          <Grid item xs={12}>
            <NotificationBox
              title={'notifications.overDue'}
              notifications={worksheet.overdue}
              subString={'invoice'}
              removeNotification={removeNotification}
              icon={'callMade'}
            />
          </Grid>
          <Grid item xs={12}>
            <NotificationBox
              title={'notifications.sendingFailed'}
              notifications={worksheet.failed}
              subString={'invoiceTo'}
              removeNotification={removeNotification}
              icon={'callMade'}
            />
          </Grid>
          <Grid item xs={12}>
            <NotificationBox
              title={'notifications.reSending'}
              notifications={worksheet.retrying}
              subString={'invoiceTo'}
              removeNotification={removeNotification}
              icon={'callMade'}
            />
          </Grid>
        </Grid>
      </Authorize>

      <Authorize allow={['Issuer agent']} fallback={null}>
        <Grid container item xs={6} spacing={2}>
          <Grid item xs={12}>
            <NotificationBox
              title={'notifications.readyToPublish'}
              notifications={worksheet.readyToPublish}
              subString={'invoicingPeriod'}
              removeNotification={removeNotification}
              icon={'assignment'}
            />
          </Grid>
          {Array.isArray(worksheet.locked) && worksheet.locked.length > 0 &&
            <Grid item xs={12}>
              <NotificationBox
                title={'notifications.locked'}
                notifications={worksheet.locked}
                subString={'invoicingPeriod'}
                removeNotification={removeNotification}
                icon={'assignment'}
              />
            </Grid>}
        </Grid>
        <Grid container item xs={6} spacing={2}>
          <Grid item xs={12}>
            <NotificationBox
              title={'notifications.invoiceSent'}
              notifications={worksheet.sent}
              subString={'invoiceFrom'}
              removeNotification={removeNotification}
              icon={'callReceived'}
            />
          </Grid>
          <Grid item xs={12}>
            <NotificationBox
              title={'notifications.readyToSendConsolidated'}
              notifications={worksheet.readyToSendConsolidated}
              subString={'consolidated'}
              removeNotification={removeNotification}
              icon={'callMerge'}
            />
          </Grid>
          <Grid item xs={12}>
            <NotificationBox
              title={'notifications.overDueConsolidated'}
              notifications={worksheet.overdueConsolidated}
              subString={'consolidated'}
              removeNotification={removeNotification}
              icon={'callMerge'}
            />
          </Grid>
          <Grid item xs={12}>
            <NotificationBox
              title={'notifications.sendingFailed'}
              notifications={worksheet.failedConsolidated}
              subString={'consolidated'}
              removeNotification={removeNotification}
              icon={'callMerge'}
            />
          </Grid>
          <Grid item xs={12}>
            <NotificationBox
              title={'notifications.reSending'}
              notifications={worksheet.retryingConsolidated}
              subString={'consolidated'}
              removeNotification={removeNotification}
              icon={'callMerge'}
            />
          </Grid>
        </Grid>
      </Authorize>
    </Grid>
  );
}
